import z from 'zod';

export type CreateUserFormSchemaValues = z.infer<typeof createUserFormSchema>;
export const createUserFormSchema = z.object({
    name: z.string().nonempty(),
    username: z.string().nonempty(),
    email: z.email().nonempty(),
    roles: z.array(z.string()).min(1),
    password: z.string().nonempty(),
    password_confirm: z.string().nonempty(),
});

export type UpdateUserFormSchemaValues = z.infer<typeof updateUserFormSchema>;
export const updateUserFormSchema = z.object({
    name: z.string().nonempty(),
    username: z.string().nonempty(),
    email: z.email().nonempty(),
    roles: z.array(z.string()),
});

export type ChangeUserPasswordFormSchemaValues = z.infer<typeof changeUserPasswordFormSchema>;
export const changeUserPasswordFormSchema = z.object({
    password: z.string().nonempty(),
    password_confirm: z.string().nonempty(),
});
